
import { Component, Vue } from 'vue-property-decorator';
import { isEmbedded, redirectExternal } from '@/utils/shopifyBridge';
import { EventBus } from '@/main';
import { reviewRequestService } from '@/services/ReviewRequestService';
import { featureUnlockService } from '@/services/FeatureUnlockService';
import { insightReviewService } from '@/services/InsightReviewService';

const REVIEW_URL = 'https://apps.shopify.com/assisty#modal-show=ReviewListingModal';

@Component
export default class ReviewRequestDialog extends Vue {
  private visible = false;
  private storeId = 0;
  private triggerEvent = '';
  private contextMessage: string | null = null;

  public mounted() {
    EventBus.$on('show-review-request-dialog', this.onShow);
  }

  public beforeDestroy() {
    EventBus.$off('show-review-request-dialog', this.onShow);
  }

  private onShow(data: { storeId: number; triggerEvent: string; contextMessage?: string }) {
    this.storeId = data.storeId;
    this.triggerEvent = data.triggerEvent;
    this.contextMessage = data.contextMessage || null;
    this.visible = true;
  }

  private dismiss() {
    this.visible = false;
    this.recordOutcome('dismissed', false);
  }

  private openReview() {
    if (isEmbedded()) {
      redirectExternal(REVIEW_URL);
    } else {
      window.open(REVIEW_URL, '_blank');
    }
    this.visible = false;
    this.recordOutcome('link_opened', true);
  }

  private async recordOutcome(code: string, success: boolean) {
    try {
      await reviewRequestService.recordRequest(
        code,
        success,
        this.triggerEvent,
        { storeId: this.storeId, timestamp: new Date().toISOString() },
      );
    } catch (error) {
      // Non-critical
    }

    // Update FeatureUnlock record with review outcome (Flow C)
    if (this.triggerEvent.startsWith('feature_unlock_')) {
      const featureCode = this.triggerEvent.replace('feature_unlock_', '');
      featureUnlockService.updateReviewStatus(featureCode, true, code).catch(() => {});
    }

    if (this.triggerEvent.startsWith('insight_')) {
      insightReviewService.recordOutcome(
        this.storeId,
        code === 'link_opened' ? 'link_opened' : 'dismissed',
      );
    }
  }
}
